import React from 'react';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
export function TermsPage() {
  return <div className="min-h-screen" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-538">
      <Navigation data-id="element-539" />

      <div className="pt-32 pb-20 px-4" data-id="element-540">
        <div className="max-w-4xl mx-auto" data-id="element-541">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-542">
            <h1 className="text-4xl sm:text-5xl font-bold mb-6" style={{
            color: 'var(--text-primary)'
          }} data-id="element-543">
              Terms of{' '}
              <span style={{
              color: 'var(--accent)'
            }} data-id="element-544">
                Service
              </span>
            </h1>
            <p className="text-sm mb-8" style={{
            color: 'var(--text-muted)'
          }} data-id="element-545">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>

            <div className="space-y-8" data-id="element-546">
              <Section title="1. Agreement to Terms" data-id="element-547">
                <p data-id="element-548">
                  By accessing or using IT Monsters's services, you agree to be
                  bound by these Terms of Service. If you disagree with any part
                  of these terms, you may not use our services.
                </p>
              </Section>

              <Section title="2. Services Description" data-id="element-549">
                <p data-id="element-550">
                  IT Monsters provides professional web design and development
                  services, including:
                </p>
                <ul data-id="element-551">
                  <li data-id="element-552">Free website demo creation</li>
                  <li data-id="element-553">Custom website design and development</li>
                  <li data-id="element-554">Website hosting setup assistance</li>
                  <li data-id="element-555">30 days of post-launch support</li>
                </ul>
              </Section>

              <Section title="3. Pricing and Payment" data-id="element-556">
                <p data-id="element-557">
                  <strong data-id="element-558">Free Demo:</strong> We provide a free website demo
                  with no obligation. You only pay if you approve the design and
                  want to launch.
                </p>
                <p data-id="element-559">
                  <strong data-id="element-560">Professional Packages:</strong> One-time payment for
                  complete website. Payment required after demo approval before
                  final launch.
                </p>
                <p data-id="element-561">
                  <strong data-id="element-562">Hosting (€10/month):</strong> Optional hosting and
                  maintenance service.
                </p>
                <p data-id="element-563">
                  All prices are in Euros (EUR). Payments are non-refundable
                  once work has commenced.
                </p>
              </Section>

              <Section title="4. Project Timeline" data-id="element-564">
                <p data-id="element-565">
                  Standard projects are completed within 24 hours from demo
                  approval. Timeline may vary based on:
                </p>
                <ul data-id="element-566">
                  <li data-id="element-567">Project complexity</li>
                  <li data-id="element-568">Client feedback response time</li>
                  <li data-id="element-569">Content availability</li>
                </ul>
              </Section>

              <Section title="5. Revisions and Changes" data-id="element-570">
                <p data-id="element-571">
                  Our package includes 3 rounds of revisions. Additional
                  revisions may incur extra charges. Major scope changes after
                  approval may require additional fees.
                </p>
              </Section>

              <Section title="6. Intellectual Property" data-id="element-572">
                <p data-id="element-573">
                  Upon full payment, you own all rights to the final website
                  design and code. Before payment, all work remains property of
                  IT Monsters.
                </p>
              </Section>

              <Section title="7. Client Responsibilities" data-id="element-574">
                <p data-id="element-575">Clients are responsible for:</p>
                <ul data-id="element-576">
                  <li data-id="element-577">Providing accurate content and materials</li>
                  <li data-id="element-578">Timely feedback and approvals</li>
                  <li data-id="element-579">
                    Domain registration and hosting (if not using our services)
                  </li>
                  <li data-id="element-580">Compliance with applicable laws</li>
                </ul>
              </Section>

              <Section title="8. Limitation of Liability" data-id="element-581">
                <p data-id="element-582">
                  IT Monsters is not liable for indirect, incidental, or
                  consequential damages arising from use of our services. Our
                  total liability is limited to the amount paid for services.
                </p>
              </Section>

              <Section title="9. Termination" data-id="element-583">
                <p data-id="element-584">
                  Either party may terminate the agreement with written notice.
                  Payments for completed work are non-refundable.
                </p>
              </Section>

              <Section title="10. Contact" data-id="element-585">
                <p data-id="element-586">For questions about these Terms, contact us at:</p>
                <p data-id="element-587">
                  Email: legal@itmonsters.agency
                  <br data-id="element-588" />
                  Telegram: @itmonsters
                </p>
              </Section>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer data-id="element-589" />
      <CookieBanner data-id="element-590" />
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="rounded-2xl border p-6 sm:p-8" style={{
    borderColor: 'var(--border)',
    backgroundColor: 'var(--bg-secondary)'
  }} data-id="element-591">
      <h2 className="text-xl sm:text-2xl font-bold mb-4" style={{
      color: 'var(--text-primary)'
    }} data-id="element-592">
        {title}
      </h2>
      <div className="space-y-3 text-sm sm:text-base [&>ul]:list-disc [&>ul]:ml-6 [&>ul]:space-y-2" style={{
      color: 'var(--text-secondary)'
    }} data-id="element-593">
        {children}
      </div>
    </div>;
}